module.exports = __webpack_public_path__ + "static/media/Covid.80c48db1.jpeg";